"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get a selector string for specified entity type and id
 * @param type (Optional) Type of entity
 * @param id (Optional) Id of entity
 */
function getEntitySelector(type, id) {
    var typeSelector = type ? "." + "_EType_" /* ENTITY_TYPE_PREFIX */ + type : '';
    var idSelector = id ? "." + "_EId_" /* ENTITY_ID_PREFIX */ + id : '';
    return '.' + "_Entity" /* ENTITY_INFO_NAME */ + typeSelector + idSelector;
}
exports.default = getEntitySelector;
//# sourceMappingURL=getEntitySelector.js.map